export const ConsentName = {
    TERMS_OF_SERVICE: 'TERMS_OF_SERVICE',
    PRIVACY_POLICY: 'PRIVACY_POLICY',
    TRANSACTIONAL_SMS_MESSAGES: 'TRANSACTIONAL_SMS_MESSAGES',
    MARKETING_SMS_MESSAGES: 'MARKETING_SMS_MESSAGES',
    TAX_DISCLOSURE: 'TAX_DISCLOSURE',
    TAX_RETURN_CONSENT: 'TAX_RETURN_CONSENT',
    RETRO_S_BACKDATE_TERMS: 'RETRO_S_BACKDATE_TERMS',
    REFERRAL_CONTACT_SHARING: 'REFERRAL_CONTACT_SHARING',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ConsentName = (typeof ConsentName)[keyof typeof ConsentName];
